import React, { useContext, useEffect, useState } from 'react';
import {
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaStar, FaHeart,
  FaBed, FaBath, FaRulerCombined, FaArrowLeft
} from 'react-icons/fa';
import '../../../assets/css/Buyer/agents/agentsdetails.css';
import MyNavbar from 'components/Buyer/navbar/MyNavbar';
import Footer from 'components/Buyer/footer/Footer';
import HeroSection from 'subscreens/general/pageheros/HeroSection';
import AppContext from 'context/AppContext';
import { Navigate } from 'react-router-dom';
import axios from 'axios';


export default function AgentsDetails({ property, agent, onBack }) {
  const { baseUrl, Navigate, baseUrlForFiles } = useContext(AppContext);
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    if (agent?.exproperties) {
      setProperties(agent.exproperties);
    }
  }, [agent]);

  return (
    <>
      <MyNavbar />
      <HeroSection
        title="Agents Details"
        subtitle="Expert professionals at your service"
        // label="Professional Team"
        image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
      // align="left"
      // size="lg"
      />

      <div className="agent-details-page agent-details-animate-fade-in">
        <div className="agent-details-container agent-details-py-8">
          {/* Back Button */}
          <button
            onClick={onBack}
            className="agent-details-back-btn"
          >
            <FaArrowLeft /> Back To Agents
          </button>

          {/* Agent Profile Card */}
          <div className="agent-details-profile-card">
            <div className="agent-details-profile-grid">
              <div className="agent-details-image-wrapper">
                <img
                  src={`${baseUrlForFiles}${agent?.profileImage}`}
                  alt={agent.firstName}
                  className="agent-details-image"
                />
              </div>

              <div className="agent-details-info-section">
                <div>
                  <div className="agent-details-header">
                    <div>
                      <h1 className="agent-details-name">{agent?.firstName} {agent?.lastName}</h1>
                      <p className="agent-details-role">{agent.role}</p>
                      <div className="agent-details-rating">
                        <FaStar />
                        <span className="agent-details-rating-value">{agent.rating}</span>
                        <span className="agent-details-rating-count">(120 Reviews)</span>
                      </div>
                    </div>
                    {/* <div className="agent-details-actions">
                      <button className="agent-details-action-btn" title="Contact">
                        <FaPhone size={14} />
                      </button>
                      <button className="agent-details-action-btn" title="Email">
                        <FaEnvelope size={14} />
                      </button>
                      <button className="agent-details-action-btn" title="View on Map">
                        <FaMapMarkerAlt size={14} />
                      </button>
                    </div> */}
                  </div>

                  {/* <div className="agent-details-about-section">
                  <h3 className="agent-details-about-title">About Me</h3>
                  <p className="agent-details-about-text">{agent.about}</p>
                </div> */}

                  <div className="agent-details-info-grid">
                    <div className="agent-details-info-column">
                      <h4 className="agent-details-info-heading">Business Information</h4>
                      <div>
                        <ul className="agent-details-info-list">
                          <li className="agent-details-info-item">
                            <span className="agent-details-info-dot"></span>
                            Active Listings: {agent.listings}
                          </li>
                          <li className="agent-details-info-item">
                            <span className="agent-details-info-dot"></span>
                            Languages: {agent.languages}
                          </li>
                        </ul>
                      </div>

                      <div className="agent-details-info-column agent-details-info-column-offset">
                        <ul className="agent-details-info-list">
                          <li className="agent-details-info-item">
                            <span className="agent-details-info-dot"></span>
                            Experience Since: {agent.experience}
                          </li>
                        </ul>
                      </div>
                      <div className="agent-details-info-column agent-details-info-column-offset">
                        <ul className="agent-details-info-list">
                          <li className="agent-details-info-item">
                            <span className="agent-details-info-dot"></span>
                            Areas: {agent.areas}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Listings Section */}
          <div className="agent-details-listings-header">
            <h2 className="agent-details-listings-title">Agent Listings</h2>
            <span className="agent-details-listings-count">
              {agent?.exproperties?.length || 0} Properties
            </span>
          </div>

          <div className="agent-details-properties-grid">
            {agent?.exproperties?.map((property) => (
              <div
                key={property.id}
                className="agent-details-property-card"
              >
                <div className="agent-details-property-image-wrapper">
                  <img
                    src={`${baseUrlForFiles}${property?.expropertyimages?.[0]?.images || ""}`}
                    alt={property.title}
                    className="agent-details-property-image"
                  />
                  {property.featured && (
                    <span className="agent-details-featured-badge">
                      <FaStar size={10} /> Featured
                    </span>
                  )}

                  {/* Hover Overlay with Details */}
                  <div className="agent-details-property-overlay">
                    <div className="agent-details-property-overlay-content">
                      <div className="agent-details-property-overlay-header">
                        <p className="agent-details-property-overlay-price">{property.price}</p>
                        <button className="agent-details-property-like-btn">
                          <FaHeart />
                        </button>
                      </div>
                      <h3 className="agent-details-property-overlay-title">{property.property_title}</h3>
                      <p className="agent-details-property-overlay-address">
                        <FaMapMarkerAlt /> {property.location}
                      </p>

                      <div className="agent-details-property-overlay-features">
                        <div className="agent-details-property-overlay-feature">
                          <FaBed className="agent-details-property-overlay-icon" />
                          <span>{property.bedrooms}</span>
                        </div>
                        <div className="agent-details-property-overlay-feature">
                          <FaBath className="agent-details-property-overlay-icon" />
                          <span>{property.bathrooms} </span>
                        </div>
                        <div className="agent-details-property-overlay-feature">
                          <FaRulerCombined className="agent-details-property-overlay-icon" />
                          <span>{property.size}</span>
                        </div>
                      </div>

                      <button
                        className="agent-details-property-view-btn"
                        onClick={() =>                          
                          Navigate("/buyer/agents/agentpropertydetails", {
                            state: {
                              property: property,
                            },
                          })
                        }
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="agent-details-property-content">
                <h3 className="agent-details-property-price">{property.price}</h3>
                <h4 className="agent-details-property-title">{property.title}</h4>
                <p className="agent-details-property-address">{property.address}</p>
                
                <div className="agent-details-property-features">
                  <div className="agent-details-property-feature">
                    <FaBed /> {property.beds} Beds
                  </div>
                  <div className="agent-details-property-feature">
                    <FaBath /> {property.baths} Baths
                  </div>
                  <div className="agent-details-property-feature">
                    <FaRulerCombined /> {property.area}
                  </div>
                </div>
              </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}